/* app/js/src/components/common/success-v-icon/success-v-icon.component.scss */
.icon {
  width: 52px;
  height: 52px;
  border: 1px #61b965 solid;
  border-radius: 26px;
  background: url(/assets/icons/success-v.png) no-repeat center;
}
/*# sourceMappingURL=success-v-icon.component.css.map */
